import { css } from '@emotion/react';

import RunState from 'types/RunState';
import { taskStateColor } from 'utils/taskStateColors';

export default function StateBadge({ state }: { state: RunState }) {
  return (
    <span
      css={css`
        display: inline-block;
        padding: 8px;

        font-size: 21px;
        line-height: 18px;
        letter-spacing: 0.08em;

        color: #fff;
      `}
      style={{ background: taskStateColor(state) }}
    >
      {state}
    </span>
  );
}
